import * as React from "react";
import { IAppPropsWithRoute } from "../../common/types";
import { useHistory, withRouter } from "react-router-dom";
import ViewBillingWidget from "./ViewBillingWidget";
import { useDispatch, useSelector } from "react-redux";
import { showNavbar } from "../../store/modules/appStateSlice";
import { RootState } from "../../store/rootReducer";

interface ViewBillingPageProps extends IAppPropsWithRoute {}

const ViewBillingPage = (props: ViewBillingPageProps): JSX.Element => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { authStore } = useSelector((state: RootState) => state);
  
  const redirecttoLoginPage = () => {
    history.push("/login");
  };

  React.useEffect(() => {
    if(authStore.data?.IsAdmin){
      dispatch(showNavbar(true));
    }
    else {
      redirecttoLoginPage()
    }
        
  }, [dispatch]);

  return <ViewBillingWidget />;
};

export default React.memo(withRouter(ViewBillingPage));
